(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-selector-components/assets/javascripts/hooks/use-swipe.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-selector-components/assets/javascripts/hooks/use-swipe.js');
"use strict";

const {
  useEffect,
  useRef
} = React;
const {
  MINIMAL_REQUIRED_SWIPE_DISTANCE
} = svs.components.tipsen.drawSelectorComponents.constants;
const resetPositions = {
  clientX: 0,
  clientY: 0
};
const useSwipe = (ref, onSwipeLeft, onSwipeRight) => {
  const startRef = useRef(resetPositions);
  const endRef = useRef(resetPositions);
  const isScrolling = useRef(false);
  const isSwiping = useRef(false);
  useEffect(() => {
    if (!ref || !onSwipeLeft || !onSwipeRight) {
      return;
    }
    const elem = ref;
    const onTouchStart = _ref => {
      let {
        changedTouches
      } = _ref;
      endRef.current = resetPositions;
      startRef.current = {
        clientX: changedTouches[0].clientX,
        clientY: changedTouches[0].clientY
      };
    };
    const onTouchEnd = _ref2 => {
      let {
        changedTouches
      } = _ref2;
      if (isSwiping.current) {
        endRef.current = {
          clientX: changedTouches[0].clientX,
          clientY: changedTouches[0].clientY
        };
        const distanceTraveledX = Math.abs(startRef.current.clientX - endRef.current.clientX);
        if (distanceTraveledX > MINIMAL_REQUIRED_SWIPE_DISTANCE) {
          if (startRef.current.clientX > endRef.current.clientX) {
            onSwipeLeft();
          } else {
            onSwipeRight();
          }
        }
      }
      startRef.current = resetPositions;
      isScrolling.current = false;
      isSwiping.current = false;
    };
    const onTouchMove = event => {
      const {
        changedTouches
      } = event;
      const distanceTravelledY = Math.abs(startRef.current.clientY - changedTouches[0].clientY);
      const distanceTravelledX = Math.abs(startRef.current.clientX - changedTouches[0].clientX);
      if (!isScrolling.current && !isSwiping.current) {
        if (distanceTravelledX > distanceTravelledY) {
          isSwiping.current = true;
        } else if (distanceTravelledY > distanceTravelledX) {
          isScrolling.current = true;
        }
      }
      if (isSwiping.current) {
        event.preventDefault();
        event.stopPropagation();
      }
    };
    if (elem) {
      elem.addEventListener('touchstart', onTouchStart);
      elem.addEventListener('touchend', onTouchEnd);
      elem.addEventListener('touchmove', onTouchMove);
    }
    return () => {
      if (elem) {
        elem.removeEventListener('touchstart', onTouchStart);
        elem.removeEventListener('touchend', onTouchEnd);
        elem.removeEventListener('touchmove', onTouchMove);
      }
    };
  }, [onSwipeLeft, onSwipeRight, ref]);
};
setGlobal('svs.components.tipsen.drawSelectorComponents.hooks.useSwipe', useSwipe);

 })(window);